import React from 'react'
import { Link } from 'react-router-dom'
import FeatureCard from '../components/FeatureCard'
import '../styles/landing.css'

const featureGroups = [
  {
    category: '🤖 Inteligencia Artificial',
    color: '#818cf8',
    items: [
      { icon: <img src="/icons/ai.png" alt="IA" style={{ width: '56px' }} />, title: 'Tutor IA Vortex', description: 'Asistente digital especializado en el temario del EXANI-II para universidades públicas y autónomas, para resolver tus dudas al instante.' },
      { icon: <img src="/icons/book.png" alt="Docs" style={{ width: '56px' }} />, title: 'Vortex Docs', description: 'Resúmenes sintéticos y cuestionarios interactivos de tus guías de estudio en segundos.' },
      { icon: <img src="/icons/robot.png" alt="Generador" style={{ width: '56px' }} />, title: 'Generador Ceneval', description: 'Crea reactivos personalizados con formato oficial de 3 opciones (A, B, C) a partir de tus notas.' },
      { icon: <img src="/icons/listen.png" alt="Texto a Audio" style={{ width: '56px' }} />, title: 'Vortex Audio', description: 'Convierte tus temas de estudio en audios narrados con voces de alta fidelidad.' },
    ],
  },
  {
    category: '📚 Estrategias de Estudio',
    color: '#34d399',
    items: [
      { icon: '📇', title: 'Flashcards', description: 'Tarjetas de memoria con repetición espaciada y autoevaluación para fijar conceptos clave.' },
      { icon: '🎧', title: 'Estudio Auditivo', description: 'Modo pasivo continuo: pregunta, pausa de reflexión y respuesta para repasar sin pantalla.' },
      { icon: '📊', title: 'Mapa de Debilidades', description: 'Diagnóstico visual por área transversal y módulo con semáforo para enfocar tu esfuerzo.' },
      { icon: '🗂️', title: 'Plan de Estudio', description: 'Cronograma inteligente adaptado a tu fecha límite de examen para cubrir todo el temario.' },
    ],
  },
  {
    category: '🎯 Evaluación y Preparación',
    color: '#fbbf24',
    items: [
      { icon: '🔭', title: 'Simulador EXANI-II', description: 'Simulación oficial de 168 reactivos, 4.5 horas y ponderación Ceneval con módulos específicos.' },
      { icon: '📋', title: 'Bancos de Reactivos', description: 'Cientos de reactivos calibrados de Comprensión Lectora, Redacción Indirecta y Matemáticas.' },
      { icon: '📖', title: 'Cursos Propedéuticos', description: 'Cursos troncales estructurados con lecciones, ejercicios prácticos y material descargable.' },
      { icon: '🧭', title: 'Métricas de Admisión', description: 'Mide tu puntaje predictivo frente al estándar de ingreso y monitorea tu progreso diario.' },
    ],
  },
  {
    category: '⚓ Módulos Especiales UNINAV 2026',
    color: '#38bdf8',
    items: [
      { icon: '🧠', title: 'Simulador Psicométrico Naval', description: 'Evaluación cronometrada de razonamiento abstracto, mecánica, poleas, engranes, visión espacial 3D y agilidad lógica.' },
      { icon: '🛡️', title: 'Evaluación Psicológica de Perfil', description: 'Inventario de 5 dimensiones: disciplina militar, tolerancia al estrés, resiliencia y liderazgo según el estándar SEMAR.' },
      { icon: '🎖️', title: 'Dictamen de Aptitud y CI Naval', description: 'Cálculo de percentil cognitivo, análisis por área y dictamen preliminar (Apto / Observaciones).' },
      { icon: '🗺️', title: 'Guía Fase Definitiva (Antón Lizardo)', description: 'Técnicas estratégicas para la entrevista personal, lenguaje corporal y consistencia psicométrica en el heroico plantel.' },
    ],
  },
]

export default function Features() {
  return (
    <section id="features" className="section">
      <div className="container">
        <div className="text-center mb-2xl">
          <h2>Herramientas integradas en Vortex EXANI-II</h2>
          <p style={{ maxWidth: '700px', margin: '0 auto' }}>
            Todo lo que necesitas para estudiar, evaluarte y asegurar tu admisión en un solo lugar.
          </p>
        </div>

        {featureGroups.map((group) => (
          <div key={group.category} style={{ marginBottom: 'var(--spacing-2xl)' }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              marginBottom: 'var(--spacing-lg)'
            }}>
              <span style={{
                width: '34px',
                height: '34px',
                borderRadius: '10px',
                background: `${group.color}22`,
                border: `1px solid ${group.color}55`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '1.1rem',
                flexShrink: 0
              }}>
                {group.category.split(' ')[0]}
              </span>
              <h3 style={{
                margin: 0,
                fontSize: '1.4rem',
                fontWeight: '800',
                color: 'var(--text-primary)'
              }}>
                {group.category}
              </h3>
            </div>

            <div className="grid grid-4">
              {group.items.map((feature, index) => (
                <FeatureCard
                  key={index}
                  icon={feature.icon}
                  title={feature.title}
                  description={feature.description}
                />
              ))}
            </div>
          </div>
        ))}

        <div className="section-cta">
          <h3>¿Listo para tomar las cosas en serio?</h3>
          <p>
            Únete a cientos de aspirantes que ya están usando Vortex EXANI-II y juntos alcancemos esa meta.
          </p>
          <div style={{ display: 'flex', gap: 'var(--spacing-md)', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/cursos" className="btn btn-primary">
              Explorar los Cursos
            </Link>
            <a href="#availability" className="btn btn-secondary">Descargar ahora</a>
          </div>
        </div>
      </div>
    </section>
  )
}
